import React, { useEffect, useState } from 'react';
import { AddButton } from 'components/Button';
import { useForm } from 'react-hook-form';

import { AdditionalDetails } from './AdditionalDetails';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { useCreate } from '../api/create';
import { blogShema } from '../validation';


const getDefaultFormValues = () => ({
  title: '',
  description: '',
  content: '',
  tag: '',
  picture: null,
  creatorID: null,
});

export const Add = ({ refetch }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const { mutate } = useCreate();
  const methods = useForm({
    defaultValues: getDefaultFormValues(),
    resolver: useYupValidationResolver(blogShema),
  });

  const onSubmit = async (values) => {
    mutate(values, {
      onSuccess: () => {
        refetch();
        handleCloseModal();
        methods.reset();
      },
    });
  };

  useEffect(() => {
    if (!openModal) {
      document.body.style.overflow = '';
      methods.reset({ ...getDefaultFormValues() });
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [openModal]);

  return (
    <>
      <AddButton
        fullWidth
        onClick={handleOpenModal}
        sx ={({ palette }) => ({
          svg: { mt: -0.5 },
          minWidth: 200,
          border: `1px solid ${palette.grey[200]}`,
        })}
        color='secondary'
      >
        Add Blog
      </AddButton>

      {openModal && (
        <AdditionalDetails
          methods={methods}
          onSubmit={onSubmit}
          handleCloseModal={handleCloseModal}
        />
      )}
    </>
  );
};
